import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetTables } from "./useGetTables"
import { Tables } from "../../Objects/Table/Tables"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useSaveTable = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetTable } = useGetTables()

  const handleSave = async (tableChange: Tables, onSuccess: any) => {
    enableLoad()

    try {
      let response = null

      if (tableChange.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.TABLE.PUT}/${tableChange.id}`, tableChange.toJSON())
      } else {
        response = await PostFormRequest(API_ROUTES.TABLE.CREATE, tableChange.toJSON())
      }

      if (response.success) {
        await handleGetTable(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSave,
  }
}
